module.exports = __webpack_public_path__ + "static/img/1005.9cc8708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/1005.png
// module id = 280
// module chunks = 1